/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EAccelerationSeverity {
  BelowThreshold = 'BelowThreshold',
  Moderate = 'Moderate',
  Severe = 'Severe'
}
